import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { ORDER_TYPE_IDS } from '../Utils/Constants/Order';
import { ORDER_TYPE_DELIVERY, ORDER_TYPE_DIRECT_SALE, ORDER_TYPE_STORE_COUNTER } from '../Utils/Constants/Service';

interface OrderTypeType {
  orderType: string;
  setOrderType: CallableFunction;
  showOrderTypeChoice: boolean;
  setShowOrderTypeChoice: (value: boolean) => void;
  getOrderTypeIdByName: (value: string) => void;
  isStoreCounter: boolean;
  setIsStoreCounter: CallableFunction;
  setIsDelivery: CallableFunction;
  isDelivery: boolean;
  setIsDirectSale: CallableFunction;
  isDirectSale: boolean;
}

const OrderTypeContext = createContext<OrderTypeType | undefined>(undefined);

export const OrderTypeProvider = ({ children }: { children: ReactNode }) => {
  const [showOrderTypeChoice, setShowOrderTypeChoice] = useState(false);

  const [orderType, setOrderType] = useState(() => {
    const storedOrderType = localStorage.getItem('order_type');
    return storedOrderType !== null ? storedOrderType : ORDER_TYPE_STORE_COUNTER;
  });

  const getOrderTypeIdByName = (orderType: string): number | null => {
    return ORDER_TYPE_IDS[orderType] ?? null;
  }

  const [ isStoreCounter, setIsStoreCounter] = useState(false);
  const [ isDelivery, setIsDelivery] = useState(false);
  const [ isDirectSale, setIsDirectSale] = useState(false);

  useEffect(() => {
    if (orderType) {
      localStorage.setItem('order_type', orderType)
    }
    setIsStoreCounter(orderType === ORDER_TYPE_STORE_COUNTER);
    setIsDelivery(orderType === ORDER_TYPE_DELIVERY);
    setIsDirectSale(orderType === ORDER_TYPE_DIRECT_SALE);
  }, [orderType])

  return (
    <OrderTypeContext.Provider value={{ orderType, setOrderType, showOrderTypeChoice, setShowOrderTypeChoice, getOrderTypeIdByName, isStoreCounter, setIsStoreCounter, isDelivery, setIsDelivery, isDirectSale, setIsDirectSale }}>
      {children}
    </OrderTypeContext.Provider>
  );
};

export const useOrderTypeContext = () => {
  const context = useContext(OrderTypeContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};
